enum CompanyHotelSettingsPriceMedianIndicationType {
	ICON = 'ICON',
	ICON_AND_BACKGROUND = 'ICON_AND_BACKGROUND'
}

export default CompanyHotelSettingsPriceMedianIndicationType;
